import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  flightSummary: {
    display: 'flex',
    alignItems: 'center',
    gap: 24,

    '& .flight-dates': {
      textTransform: 'capitalize',
    },

    '& >div': {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      [Theme.breakpoints.up('md')]: {
        gap: 8,
      },
    },
    '& .icon': {
      width: 24,
      fill: Theme.palette.gray[800],
    },
    '& .icon, .confirmation': {
      display: 'none',
      [Theme.breakpoints.up('md')]: {
        display: 'inline-block',
      },
    },
    '& .itinerary-title': {
      color: Theme.palette.primary.main,
      fontSize: Theme.typography.size[6],
    },
    '& .summary-items': {
      color: Theme.palette.gray[750],
      fontSize: Theme.typography.size[2],
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[3],
      },
      '& span:after': {
        content: "'|'",
        padding: '0px 8px',
      },
      '& span:last-child::after': {
        content: "''",
        padding: 0,
      },
      '& span:nth-child(2)::after': {
        content: "''",
        [Theme.breakpoints.up('md')]: {
          content: "'|'",
          padding: '0px 8px',
        },
      },
    },

    '& .label': {
      display: 'block',
      fontFamily: Theme.typography.base.semiBold,
      color: Theme.palette.primary.main,
      fontSize: Theme.typography.size[2],
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[3],
      },
    },

    '& a': {
      color: Theme.palette.primary.light,
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[1],
      margin: 0,
    },
  },
}));

export default useStyles;
